import { CommonModule, NgIf } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService } from '../../../services/http.service';
import { ActivatedRoute, Router } from '@angular/router';

interface APIResponse {
    userId: string;
    fullName: string;
    firstName: string;
    lastName: string;
    email: string;
    mobileNumber: string;
    profilePicture: string | null;
    roleName: string;
    schoolName: string | null;
    status: string;
    yearLevel: number;
}

interface ApiDataResponse {
    status: boolean;
    message: string;
    data: APIResponse;
}

@Component({
    selector: 'app-user-view-dialog',
    templateUrl: './view-dialog.component.html',
    styleUrls: ['./view-dialog.component.scss'],
    imports: [NgIf, CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserViewDialogComponent implements OnInit {
    
    loading = false;
    userData: APIResponse | null = null;
    
    constructor(
        public dialogRef: MatDialogRef<UserViewDialogComponent>,
        private httpService: HttpService,
        private snackBar: MatSnackBar,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public user: { id: string }
    ) { }
    
    ngOnInit(): void {
        this.fetchViewUsers(this.user.id);
    }
    
    fetchViewUsers(id: string): void {
        this.loading = true;
        this.httpService.get<ApiDataResponse>(`users/${id}`).subscribe({
            next: ({ data }) => {
                this.userData = data;
            },
            error: (error) => {
                console.error('Failed to load user:', error);
                this.snackBar.open('Failed to load user details.', 'Close', { duration: 3000 });
                this.loading = false;
            },
            complete: () => {
                this.loading = false;
            }
        });
    }
    
    onCancel(): void {
        const search = this.route.snapshot.queryParamMap.get('search');
        
        if (search) {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { search: null },
                queryParamsHandling: 'merge'
            });
        }
        
        this.dialogRef.close(false);
    }
}
